import useRouteToUrl from '../internal/useRouteToUrl';
import useRoute from '../public/useRoute/useRoute';
export default function useActionHrefAdapter() {
    const [currentRoute] = useRoute();
    const routeToUrl = useRouteToUrl();
    return (href)=>{
        if (href == null || typeof href === 'string') {
            return href;
        }
        return routeToUrl(href, currentRoute);
    };
}

//# sourceMappingURL=useActionHrefAdapter.js.map